import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAddressAddUpdateProps } from '@msdyn365-commerce-modules/address';

interface IBusinessAccountAddressViewProps {
    BusinessAccountAddress: any;
    showAddOrUpdateAddress: IAddressAddUpdateProps;
}

const AddressAddUpdate: React.FC<IAddressAddUpdateProps> = ({
    AddressForm,
    heading,
    items,
    hasError,
    error,
    isShowSaveButton,
    saveButton,
    isShowCancelButton,
    cancelButton
}) => {
    return (
        <Node {...AddressForm}>
            {heading}
            {items &&
                items.map(item => (
                    <Node {...item.AddressItem} key={item.key}>
                        {item.label}
                        {hasError && item.alert}
                        {item.input}
                    </Node>
                ))}
            {hasError && (
                <Node {...error.AddressError}>
                    {error.title}
                    {error.message}
                </Node>
            )}
            {isShowSaveButton && saveButton}
            {isShowCancelButton && cancelButton}
        </Node>
    );
};

const BusinessAccountAddressView: React.FC<IBusinessAccountAddressViewProps> = ({ BusinessAccountAddress, showAddOrUpdateAddress }) => {
    return (
        <Module {...BusinessAccountAddress}>
            <AddressAddUpdate {...showAddOrUpdateAddress} />
        </Module>
    );
};

export default BusinessAccountAddressView;
